import { getProcessedPayslipsAggregate } from "@/api/payslips";
import Card from "@/components/Card";
import DataTable from "@/components/ui/DataTable";
import { months } from "@/utils/date-format";
import React, { useEffect } from "react";
import { getColumns } from "./columns";
import { usePayContext } from "@/context/PayContext";
import { AggregatePayslip } from "@/models/payslips.model";
import { Skeleton } from "@/components/ui/skeleton";
import { toast } from "@/hooks/use-toast";

function ProcessedPayDataTable() {
  const {
    selectedMonth,
    selectedYear,
    isProcessListChanged,
    setIsProcessListChanged,
  } = usePayContext();

  const [data, setData] = React.useState<AggregatePayslip[]>([]);

  useEffect(() => {
    const getData = async () => {
      if (!selectedMonth || !selectedYear) return;

      try {
        const data = await getProcessedPayslipsAggregate(
          Number(selectedYear),
          months.indexOf(selectedMonth) + 1
        );
        console.log(data);
        setData(data);
      } catch (err) {
        console.error(err);
        toast({
          variant: "destructive",
          title: "payslips",
          description: "Please try again later",
        })
      }
    };
    getData();
  }, [selectedMonth, selectedYear]);

  // Separate effect for handling process list changes
  useEffect(() => {
    console.log("isProcessListChanged", isProcessListChanged);

    if (isProcessListChanged && selectedMonth && selectedYear) {
      const getData = async () => {
        const data = await getProcessedPayslipsAggregate(
          Number(selectedYear),
          months.indexOf(selectedMonth) + 1
        );
        setData(data);
        setIsProcessListChanged(false);
      };
      getData();
    }
  }, [isProcessListChanged, selectedMonth, selectedYear]);

  const deleteProcessedListRow = (id: number) => {
    setData((prev) => prev.filter((item) => item.payslipId !== id));
  };

  if (!selectedMonth || !selectedYear) {
    return <Skeleton className="h-full w-full " />;
  }
  return (
    <Card styles="w-full h-full">
      <div className="rounded-md w-full h-full p-5 bg-white outline outline-2 outline-gray-100 flex flex-col">
        <div className="flex mb-4 justify-between items-start">
          <div className="flex flex-col gap-3">
            <div className="font-bold mt-2 text-xl">Processed List</div>
            <div className="text-sm text-gray-500">
              View payslips, edit pay items or remove processed payslips.
            </div>
          </div>
        </div>
        <div className="h-full max-h-full overflow-y-auto">
          <DataTable
            columns={getColumns(deleteProcessedListRow)}
            data={data}
            containerClassname="max-h-72" // Customizable styles
            tableCaption={`A total of ${data.length} employees with processed payslips.`}
          />
        </div>
      </div>
    </Card>
  );
}
export default ProcessedPayDataTable;
